export default {"src":"/_next/static/media/Arthritis.8e9627e9.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};